import { graphql } from '@api/generated';

export const callContinuityChangedSubscription = graphql(`
  subscription callContinuityChanged {
    callContinuityChanged {
      tenantId
      isEnabled
    }
  }
`);
